/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Fn } from './Fn';

const { GlobalVar } = Utils;

class EnterpriseStatementVoucher extends Fn {
    constructor() {
        super();
        this.baseUrl += '/enterpriseStatementVoucher';
    }

    data({
        voucherSn,
        enterpriseName,
        remarks,
        enterpriseId,
        isCanRelated,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/data', {
            voucherSn,
            enterpriseName,
            remarks,
            enterpriseId,
            isCanRelated,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    findListWithStat({
        voucherSn,
        enterpriseName,
        remarks,
        enterpriseId,
        isCanRelated,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/findListWithStat', {
            voucherSn,
            enterpriseName,
            remarks,
            enterpriseId,
            isCanRelated,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id } = {}) {
        return super.get('/get', { id }).then(json => {
            const { voucherImage } = json.data.data.enterpriseStatementVoucher;
            if (!voucherImage) {
                json.data.data.enterpriseStatementVoucher.voucherImage = [];
            } else {
                json.data.data.enterpriseStatementVoucher.voucherImage = voucherImage
                    .split(',')
                    .reduce((prev, curr) => {
                        prev.push({
                            name: curr,
                            address: GlobalVar.fileBasePath + curr,
                        });
                        return prev;
                    }, []);
            }
            return json;
        });
    }

    save({ id, enterpriseId, voucherImage, voucherSn, voucherAmount, remarks } = {}) {
        const voucherImageStr = voucherImage
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            enterpriseId,
            voucherImage: voucherImageStr,
            voucherSn,
            voucherAmount,
            remarks,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAssociatible } = {}) {
        return super.post('/status', {
            id,
            isAssociatible,
        });
    }
}

export default new EnterpriseStatementVoucher();
export { EnterpriseStatementVoucher };
